import { Descriptions, Typography } from 'antd'
import { createStyles } from 'antd-style'

import { ManagerLink } from '../ManagerLink'

const useStyles = createStyles(({ prefixCls, token }) => ({
  detail: {
    marginBlock: token.marginSM,
    paddingBlockStart: token.padding,
    paddingBlockEnd: token.paddingXS,
    paddingInline: token.padding,
    border: `1px solid ${token.colorWarningBorder}`
  }
}))

export const RechargeDescription = () => {
  const { styles } = useStyles()

  return (
    <>
      <div>请线下打款至“上海金意电子商务有限公司”，账号信息如下：</div>
      <Descriptions
        bordered={false}
        className={styles.detail}
        colon={false}
        column={1}
        size='middle'
        items={[
          {
            label: <Typography.Text type='warning'>开户名:</Typography.Text>,
            children: (
              <Typography.Text type='warning'>
                上海金意电子商务有限公司
              </Typography.Text>
            )
          },
          {
            label: <Typography.Text type='warning'>开户行:</Typography.Text>,
            children: (
              <Typography.Text type='warning'>
                中国建设银行淮北惠黎支行
              </Typography.Text>
            )
          },
          {
            label: <Typography.Text type='warning'>开户账号:</Typography.Text>,
            children: (
              <Typography.Text type='warning'>
                34001648608059336699-5162
              </Typography.Text>
            )
          }
        ]}
        styles={{
          label: { width: '5em', justifyContent: 'end' }
        }}
      />
      <div>
        打款完成后，请关注交易平台会员账户资金变动情况。如有异议，请联系您的客户经理
        <ManagerLink />。
      </div>
    </>
  )
}
